"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  KeyboardArrowBottomRight: ['keyboard-arrow-bottom-right', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.75 0.747L23.25 23.247', 'M23.25 16.497L23.25 23.247 16.5 23.247']],
  KeyboardArrowUp: ['keyboard-arrow-up', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12 23.247L12 0.747', 'M8.25 4.497L12 0.747 15.75 4.497']],
  KeyboardArrowDown: ['keyboard-arrow-down', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12 23.247L12 0.747', 'M8.25 19.497L12 23.247 15.75 19.497']],
  KeyboardButtonDirection: ['keyboard-button-direction', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6 20.247L3.75 17.997 6 15.747', 'M3.75 17.997L8.25 17.997', 'M18 20.247L20.25 17.997 18 15.747', 'M20.25 17.997L15.75 17.997', 'M14.25 5.997L12 3.747 9.75 5.997', 'M12 3.747L12 8.247', 'M1.500 13.497 L10.500 13.497 L10.500 22.497 L1.500 22.497 Z', 'M13.500 13.497 L22.500 13.497 L22.500 22.497 L13.500 22.497 Z', 'M7.500 1.497 L16.500 1.497 L16.500 10.497 L7.500 10.497 Z']],
  KeyboardCommand: ['keyboard-command', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M19.5,15.747a3.75,3.75,0,1,1-3.75,3.75V4.5a3.75,3.75,0,1,1,3.75,3.75H4.5A3.75,3.75,0,1,1,8.25,4.5v15a3.75,3.75,0,1,1-3.75-3.75Z']],
  KeyboardDelete: ['keyboard-delete', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.500 1.497 L22.500 1.497 L22.500 22.497 L1.500 22.497 Z', 'M16.5 9.747L12 14.247', 'M12 9.747L16.5 14.247', 'M11.121,6H18a1.5,1.5,0,0,1,1.5,1.5v9A1.5,1.5,0,0,1,18,18H11.121a1.5,1.5,0,0,1-1.06-.439L4.72,12.527a.749.749,0,0,1,0-1.06l5.341-5.031A1.5,1.5,0,0,1,11.121,6Z']],
  KeyboardAlt: ['keyboard-alt', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M18 14.997L18 8.997', 'M16.5 8.997L19.5 8.997', 'M12,9v4.5A1.5,1.5,0,0,0,13.5,15H15', 'M6,15V10.5a1.5,1.5,0,0,1,3,0V15', 'M6 11.997L9 11.997', 'M1.500 1.497 L22.500 1.497 L22.500 22.497 L1.500 22.497 Z']],
  KeyboardArrowPrevious: ['keyboard-arrow-previous', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25 11.997L5.25 11.997', 'M9 15.747L5.25 11.997 9 8.247', 'M0.75 1.497L0.75 22.497']],
  KeyboardArrowTopLeft: ['keyboard-arrow-top-left', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.75 0.747L23.25 23.247', 'M0.75 8.247L0.75 0.747 8.25 0.747']],
  KeyboardArrowReturn1: ['keyboard-arrow-return-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M5.25 23.247L0.75 18.747 5.25 14.247', 'M.75,18.747h18a4.5,4.5,0,0,0,4.5-4.5v-9a4.5,4.5,0,0,0-4.5-4.5H10.5']],
  KeyboardArrowReturn: ['keyboard-arrow-return', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M5.25 21.747L0.75 17.247 5.25 12.747', 'M.75,17.247h15a7.5,7.5,0,0,0,0-15h-6']],
  KeyboardAsterisk1: ['keyboard-asterisk-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12 1.497L12 22.497', 'M22.5 17.772L1.5 6.222', 'M1.5 17.772L22.5 6.222']],
  KeyboardAsterisk3: ['keyboard-asterisk-3', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.75 11.997L23.25 11.997', 'M18.75 22.497L5.25 1.497', 'M5.25 22.497L18.75 1.497']],
  KeyboardAsterisk: ['keyboard-asterisk', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12 1.497L12 22.497', 'M22.5 11.997L1.5 11.997', 'M19.424 4.572L4.576 19.421', 'M19.424 19.421L4.576 4.572']],
  KeyboardOption: ['keyboard-option', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.500 1.497 L22.500 1.497 L22.500 22.497 L1.500 22.497 Z', 'M18 10.497L13.5 10.497', 'M6 10.497L9 10.497 12 14.997 18 14.997']],
  KeyboardShift1: ['keyboard-shift-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M18.75,12.747H22.5a.75.75,0,0,0,.562-1.246L13.094,1.221a1.5,1.5,0,0,0-2.188,0L.939,11.5A.75.75,0,0,0,1.5,12.747H5.25v9a1.5,1.5,0,0,0,1.5,1.5h10.5a1.5,1.5,0,0,0,1.5-1.5Z']],
  KeyboardPowerOff: ['keyboard-power-off', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6 5.997L12 11.997', 'M6 8.997L6 5.997 9 5.997', 'M1.500 1.497 L22.500 1.497 L22.500 22.497 L1.500 22.497 Z', 'M12,6a6,6,0,1,1-6,6']],
  KeyboardAsterisk2: ['keyboard-asterisk-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21,8.953H17.2l1.9-3.295a1.5,1.5,0,0,0-.549-2.049l-2.6-1.5a1.5,1.5,0,0,0-2.049.549L12,5.953l-1.9-3.3a1.5,1.5,0,0,0-2.049-.549l-2.6,1.5A1.5,1.5,0,0,0,4.9,5.658L6.8,8.953H3a1.5,1.5,0,0,0-1.5,1.5v3a1.5,1.5,0,0,0,1.5,1.5H6.8L4.9,18.247A1.5,1.5,0,0,0,5.451,20.3l2.6,1.5a1.5,1.5,0,0,0,2.049-.549L12,17.953l1.9,3.294a1.5,1.5,0,0,0,2.049.549l2.6-1.5a1.5,1.5,0,0,0,.549-2.049l-1.9-3.294H21a1.5,1.5,0,0,0,1.5-1.5v-3A1.5,1.5,0,0,0,21,8.953Z']],
  KeyboardButton: ['keyboard-button', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.500 1.497 L22.500 1.497 L22.500 22.497 L1.500 22.497 Z']],
  KeyboardArrowBottomLeft: ['keyboard-arrow-bottom-left', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25 0.747L0.75 23.247', 'M0.75 16.497L0.75 23.247 7.5 23.247']],
  KeyboardArrowNext: ['keyboard-arrow-next', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M18.75 11.997L0.75 11.997', 'M15 15.747L18.75 11.997 15 8.247', 'M23.25 1.497L23.25 22.497']],
  KeyboardPageDown: ['keyboard-page-down', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.75 23.247L11.75 0.747', 'M8 19.497L11.75 23.247 15.5 19.497', 'M7.25 11.247L16.25 11.247', 'M7.25 14.247L16.25 14.247']],
  KeyboardReturn: ['keyboard-return', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6,13.5h7.5A4.5,4.5,0,0,0,18,9V6.747', 'M9.75 9.747L6 13.497 9.75 17.247', 'M1.500 1.497 L22.500 1.497 L22.500 22.497 L1.500 22.497 Z']],
  KeyboardShift: ['keyboard-shift', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.500 1.497 L22.500 1.497 L22.500 22.497 L1.500 22.497 Z', 'M16.5,12h2.248a.75.75,0,0,0,.531-1.28l-6.3-5.86a1.5,1.5,0,0,0-1.948,0L4.72,10.717A.75.75,0,0,0,5.25,12H7.5v6A1.5,1.5,0,0,0,9,19.5h6A1.5,1.5,0,0,0,16.5,18Z']],
  KeyboardArrowLeft: ['keyboard-arrow-left', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25 12.497L0.75 12.497', 'M4.5 16.247L0.75 12.497 4.5 8.747']],
  KeyboardReturn1: ['keyboard-return-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9 11.997L18 11.997', 'M12.75 8.247L9 11.997 12.75 15.747', 'M1.500 1.497 L22.500 1.497 L22.500 22.497 L1.500 22.497 Z', 'M6 7.497L6 16.497']],
  KeyboardPageUp: ['keyboard-page-up', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12 23.247L12 0.747', 'M8.25 4.497L12 0.747 15.75 4.497', 'M7.5 11.247L16.5 11.247', 'M7.5 14.247L16.5 14.247']],
  KeyboardArrowTopRight: ['keyboard-arrow-top-right', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25 0.747L0.75 23.247', 'M23.25 8.247L23.25 0.747 15.75 0.747']],
  KeyboardEject: ['keyboard-eject', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.500 1.497 L22.500 1.497 L22.500 22.497 L1.500 22.497 Z', 'M6.000 14.997 L18.000 14.997 L18.000 17.997 L6.000 17.997 Z', 'M11.47,6.527l-4.83,4.83a.375.375,0,0,0,.265.64H17.1a.375.375,0,0,0,.265-.64l-4.83-4.83A.749.749,0,0,0,11.47,6.527Z']],
  KeyboardArrowRight: ['keyboard-arrow-right', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25 12.497L0.75 12.497', 'M19.5 16.247L23.25 12.497 19.5 8.747']]
};
exports["default"] = _default;